import React, { useCallback } from 'react'
import { useHistory } from 'react-router-dom'

import endImage from '../../assets/end-image.svg'

import usePersistedState from '../../hooks/usePersistedState'

import Button from '../../components/Button'
import Header from '../../components/Header'

import { Content, HandleNew } from './styles'
import { UserData } from '../../utils/interfaces'
import Container from '../../components/Container'
import Line from '../../components/Line'

const End: React.FC = () => {
  const [userData] = usePersistedState<UserData>('userData', {} as UserData)

  const history = useHistory()

  const handleNewParticipant = useCallback(() => {
    history.push('/')

    localStorage.removeItem('@AspADSFamiliaV2:acceptTerms')
    localStorage.removeItem('@AspADSFamiliaV2:authorizeTitularPayment')
    localStorage.removeItem('@AspADSFamiliaV2:goalsSelected')
    localStorage.removeItem('@AspADSFamiliaV2:PercentualValuePercent')
    localStorage.removeItem('@AspADSFamiliaV2:receiveTypeSelected')
    localStorage.removeItem('@AspADSFamiliaV2:TimeValueYears')
    localStorage.removeItem('@AspADSFamiliaV2:totalRentability')
    localStorage.removeItem('@AspADSFamiliaV2:userDetails')
    localStorage.removeItem('@AspADSFamiliaV2:userData')
  }, [history])

  return (
    <>
      <Header />
      <Container>
        <Content>
          <strong>
            Pronto! Seu pedido de adesão ao Plano Aspprev Família foi salvo
            sucesso!
          </strong>
          <img src={endImage} alt="Finalizar" />

          <p>
            Agora nossos especialistas irão conferir todos os detalhes para a
            conclusão da sua adesão.
          </p>

          <div>
            <strong>ACESSE O NOSSO SITE:</strong>
            <a
              href="https://aspprev.com.br/"
              target="_blank"
              rel="noopener noreferrer"
            >
              www.aspprev.com.br
            </a>
          </div>

          <Line />

          <HandleNew>
            <h4>
              {userData.name.split(' ')[0]}, que tal realizar a adesão de mais
              algum familiar?
            </h4>
            <Button
              type="button"
              color="blue"
              width="large"
              onClick={handleNewParticipant}
            >
              Sim, eu quero!
            </Button>
          </HandleNew>
        </Content>
      </Container>
    </>
  )
}

export default End
